import { render, staticRenderFns } from "./change_password.vue?vue&type=template&id=6fce68a5&scoped=true"
import script from "./change_password.vue?vue&type=script&lang=js"
export * from "./change_password.vue?vue&type=script&lang=js"
import style0 from "./change_password.vue?vue&type=style&index=0&id=6fce68a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce68a5",
  null
  
)

/* custom blocks */
import block0 from "./change_password.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports